import * as React from 'react';
const SvgCancel = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 16.003a8 8 0 100-16 8 8 0 000 16zm2.404-11.82A1 1 0 1111.818 5.6L9.414 8.003l2.404 2.404a1 1 0 01-1.414 1.414L8 9.417 5.596 11.82a1 1 0 01-1.414-1.414l2.404-2.404-2.404-2.404a1 1 0 011.414-1.415L8 6.59l2.404-2.405v-.001z"
            fill="currentColor"
        />
    </svg>
);
export default SvgCancel;
